
<div class="h-100">
  <navbar></navbar>
  <component :is="view.component"></component>
</div>
